import React, { useState, useEffect } from "react";
import Collapsible from "react-collapsible";
import { Config } from "../../../../../Config";
import axios from "axios";
import { formatDate } from "../../../../../Helper_functions";

const CXAdminDashboard = (props) => {
  const [SystemUsageIsOpen, setSystemUsageIsOpen] = useState(true);
  const [SecurityProfilesIsOpen, setSecurityProfilesIsOpen] = useState(false);
  const [AiRecommendationIsOpen, setAiRecommendationIsOpen] = useState(false);
  const [AdminDashboardData, setAdminDashboardData] = useState({
    totalUsers: 0,
    totalActiveUser: 0,
    totalEmployees: 0,
    numOfSecurityProfiles: 0,
    numOfSuperAdmins: 0,
    numOfHRAdmins: 0,
    numOfCXAdmins: 0,
    numOfMSS: 0,
    numOfESS: 0,
    lastSkillRecommendation: 0,
    lastDemandPrediction: 0,
  });
  const [AdminPositionData, setAdminPositionData] = useState({
    totalPositions: 0,
    lastJPARecommendation: 0,
    lastCandidateRecommendation: 0,
  });

  const fetchAdminDashboardData = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL + Config.AuthBaseURL + "/api/admin/dashboard",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        if (Res.data) setAdminDashboardData(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchAdminPositionData = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionMngURL +
        "/api/position/dashboard/admin",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        if (Res.data) {
          setAdminPositionData(Res.data);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  useEffect(() => {
    fetchAdminDashboardData();
    fetchAdminPositionData();
  }, []);

  const formatTheDate = (date) => {
    if (date) return formatDate(new Date(date));
    return date;
  };

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  return (
    <div className="dashboard-pages-content cx-admin-dashboard">
      {window.innerWidth > 450 ? (
        <section>
          <div className="section-title">
            {translateText("system_usage_summary")}
          </div>
          <div className="content">
            <div className="row">
              <div className="col-desc">{translateText("total_users")}</div>
              <div className="col-content">{AdminDashboardData.totalUsers}</div>
            </div>
            <div className="row">
              <div className="col-desc">
                {translateText("total_active_users")}
              </div>
              <div className="col-content">
                {AdminDashboardData.totalActiveUser}
              </div>
            </div>
            <div className="row">
              <div className="col-desc">{translateText("total_employees")}</div>
              <div className="col-content">
                {AdminDashboardData.totalEmployees}
              </div>
            </div>
            <div className="row">
              <div className="col-desc">{translateText("total_positions")}</div>
              <div className="col-content">
                {AdminPositionData.totalPositions}
              </div>
            </div>
          </div>
        </section>
      ) : (
        <section>
          <Collapsible
            onOpening={() => setSystemUsageIsOpen(true)}
            open
            onClose={() => setSystemUsageIsOpen(false)}
            transitionTime={200}
            trigger={
              <div className="trigger">
                <div className="section-title">
                  {translateText("system_usage_summary")}
                </div>
                <i
                  className={
                    SystemUsageIsOpen
                      ? "feather-chevron-down i-rotated"
                      : "feather-chevron-down"
                  }
                ></i>
              </div>
            }
          >
            <div className="content">
              <div className="row">
                <div className="col-desc">{translateText("total_users")}</div>
                <div className="col-content">
                  {AdminDashboardData.totalUsers}
                </div>
              </div>
              <div className="row">
                <div className="col-desc">
                  {" "}
                  {translateText("total_active_users")}
                </div>
                <div className="col-content">
                  {AdminDashboardData.totalActiveUser}
                </div>
              </div>
              <div className="row">
                <div className="col-desc">
                  {translateText("total_employees")}
                </div>
                <div className="col-content">
                  {AdminDashboardData.totalEmployees}
                </div>
              </div>
              <div className="row">
                <div className="col-desc">
                  {translateText("total_positions")}
                </div>
                <div className="col-content">
                  {AdminPositionData.totalPositions}
                </div>
              </div>
            </div>
          </Collapsible>
        </section>
      )}
      <hr className="line" />
      {window.innerWidth > 450 ? (
        <section>
          <div className="section-title">
            {translateText("sec_profiles_overview")}
          </div>
          <div className="content">
            <div className="row">
              <div className="col-desc">
                {translateText("no_of_sec_profiles")}
              </div>
              <div className="col-content">
                {AdminDashboardData.numOfSecurityProfiles}
              </div>
            </div>
            <div className="row">
              <div className="col-desc">{translateText("superadmins")}</div>
              <div className="col-content">
                {AdminDashboardData.numOfSuperAdmins}
              </div>
            </div>
            <div className="row">
              <div className="col-desc">{translateText("hr_admins")}</div>
              <div className="col-content">
                {AdminDashboardData.numOfHRAdmins}
              </div>
            </div>
            <div className="row">
              <div className="col-desc">{translateText("cx_admins")}</div>
              <div className="col-content">
                {AdminDashboardData.numOfCXAdmins}
              </div>
            </div>
            <div className="row">
              <div className="col-desc">
                {translateText("manager_self_service")}
              </div>
              <div className="col-content">{AdminDashboardData.numOfMSS}</div>
            </div>
            <div className="row">
              <div className="col-desc">
                {translateText("employee_self_service")}
              </div>
              <div className="col-content">{AdminDashboardData.numOfESS}</div>
            </div>
          </div>
        </section>
      ) : (
        <section>
          <Collapsible
            onOpening={() => setSecurityProfilesIsOpen(true)}
            onClose={() => setSecurityProfilesIsOpen(false)}
            transitionTime={200}
            trigger={
              <div className="trigger">
                <div className="section-title">
                  {translateText("sec_profiles_overview")}
                </div>
                <i
                  className={
                    SecurityProfilesIsOpen
                      ? "feather-chevron-down i-rotated"
                      : "feather-chevron-down"
                  }
                ></i>
              </div>
            }
          >
            <div className="content">
              <div className="row">
                <div className="col-desc">
                  {translateText("no_of_sec_profiles")}
                </div>
                <div className="col-content">
                  {AdminDashboardData.numOfSecurityProfiles}
                </div>
              </div>
              <div className="row">
                <div className="col-desc">{translateText("superadmins")}</div>
                <div className="col-content">
                  {AdminDashboardData.numOfSuperAdmins}
                </div>
              </div>
              <div className="row">
                <div className="col-desc">{translateText("hr_admins")}</div>
                <div className="col-content">
                  {AdminDashboardData.numOfHRAdmins}
                </div>
              </div>
              <div className="row">
                <div className="col-desc">{translateText("cx_admins")}</div>
                <div className="col-content">
                  {AdminDashboardData.numOfCXAdmins}
                </div>
              </div>
              <div className="row">
                <div className="col-desc">
                  {translateText("manager_self_service")}
                </div>
                <div className="col-content">{AdminDashboardData.numOfMSS}</div>
              </div>
              <div className="row">
                <div className="col-desc">
                  {translateText("employee_self_service")}
                </div>
                <div className="col-content">{AdminDashboardData.numOfESS}</div>
              </div>
            </div>
          </Collapsible>
        </section>
      )}
      <hr className="line" />
      {window.innerWidth > 450 ? (
        <section>
          <div className="section-title">
            {translateText("al_recommendation_at_a_glance")}
          </div>
          <div className="content">
            <div className="row">
              <div className="col-desc">
                {translateText("last_jpa_recommendation")}
              </div>
              <div className="col-content">
                {formatTheDate(AdminPositionData.lastJPARecommendation)}
              </div>
            </div>
            <div className="row">
              <div className="col-desc">
                {translateText("last_candidate_recommendation")}
              </div>
              <div className="col-content">
                {formatTheDate(AdminPositionData.lastCandidateRecommendation)}
              </div>
            </div>
            <div className="row">
              <div className="col-desc">
                {translateText("laste_skill_recommendation")}
              </div>
              <div className="col-content">
                {formatTheDate(AdminDashboardData.lastSkillRecommendation)}
              </div>
            </div>
            <div className="row">
              <div className="col-desc">
                {translateText("last_job_skills_demand_prediciton")}
              </div>
              <div className="col-content">
                {formatTheDate(AdminDashboardData.lastDemandPrediction)}
              </div>
            </div>
          </div>
        </section>
      ) : (
        <section>
          <Collapsible
            onOpening={() => setAiRecommendationIsOpen(true)}
            onClose={() => setAiRecommendationIsOpen(false)}
            transitionTime={200}
            trigger={
              <div className="trigger">
                <div className="section-title">
                  {translateText("al_recommendation_at_a_glance")}
                </div>
                <i
                  className={
                    AiRecommendationIsOpen
                      ? "feather-chevron-down i-rotated"
                      : "feather-chevron-down"
                  }
                ></i>
              </div>
            }
          >
            <div className="content">
              <div className="row">
                <div className="col-desc">
                  {translateText("last_jpa_recommendation")}
                </div>
                <div className="col-content">
                  {formatTheDate(AdminPositionData.lastJPARecommendation)}
                </div>
              </div>
              <div className="row">
                <div className="col-desc">
                  {translateText("last_candidate_recommendation")}
                </div>
                <div className="col-content">
                  {formatTheDate(AdminPositionData.lastCandidateRecommendation)}
                </div>
              </div>
              <div className="row">
                <div className="col-desc">
                  {translateText("laste_skill_recommendation")}
                </div>
                <div className="col-content">
                  {formatTheDate(AdminDashboardData.lastSkillRecommendation)}
                </div>
              </div>
              <div className="row">
                <div className="col-desc">
                  {translateText("last_job_skills_demand_prediciton")}
                </div>
                <div className="col-content">
                  {formatTheDate(AdminDashboardData.lastDemandPrediction)}
                </div>
              </div>
            </div>
          </Collapsible>
        </section>
      )}
    </div>
  );
};

export default CXAdminDashboard;
